import React from 'react';
import {connect} from 'react-redux';
import {Field, formValueSelector, InjectedFormProps, reduxForm} from 'redux-form'
import {Button, Card, CardBody, Col, FormGroup} from 'reactstrap';
import validate, {SearchArmyListParams} from "./validate";
import {AppState} from "@Redux/store";
import ReduxFormInput from "@Utils/ReduxFormInput";
import ReduxFormSelect from "@Utils/ReduxFormSelect";
import {ArmyView} from "@Selectors/builder/myBuilder/builder/new/view/ArmyView";
import {VersionGameView} from "@Selectors/common/view/VersionGameView";
import {VersionGame} from "@Models";
import ReduxFormCategorySelect from "@Utils/ReduxFormCategorySelect";
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

interface Props {
  versions: Array<VersionGameView>,
  armies: Array<ArmyView>,
  onSubmit: (values: SearchArmyListParams) => void,
  canSubmit: boolean,
}

export const Form: React.FC<Props & InjectedFormProps<SearchArmyListParams, Props>> = ({
                                                                                         versions,
                                                                                         armies,
                                                                                         handleSubmit,
                                                                                         canSubmit
                                                                                       }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Col sm="12">
        <Card className="card-border">
          <CardBody>
            <h2 className="text-center"><FormattedMessage {...defaultMessages.searchListIndexSearchList} /></h2>

            <FormGroup row={true}>
              <Col xs="12" md={6} lg="4">
                <Field
                  name="versionId"
                  type="text"
                  datas={versions}
                  component={ReduxFormCategorySelect}
                  label={defaultMessages.armyListFormVersionTitle}
                  placeHolder={defaultMessages.armyListFormVersionPlaceholder}
                />
              </Col>
              <Col xs="12" md={6} lg="4">
                <Field
                  name="armyId"
                  type="text"
                  datas={armies}
                  component={ReduxFormSelect}
                  label={defaultMessages.armyListFormArmyTitle}
                  placeHolder={defaultMessages.armyListFormArmyPlaceholder}
                />
              </Col>
            </FormGroup>

            <FormGroup row={true}>
              <Col xs="12" md={6} lg="4">
                <Field
                  name="min"
                  type="number"
                  min={0}
                  step={1}
                  component={ReduxFormInput}
                  label={defaultMessages.armyListFormMinTitle}
                  placeHolder={defaultMessages.armyListFormMinPlaceholder}
                />
              </Col>
              <Col xs="12" md={6} lg="4">
                <Field
                  name="max"
                  type="number"
                  min={0}
                  step={1}
                  component={ReduxFormInput}
                  label={defaultMessages.armyListFormMaxTitle}
                  placeHolder={defaultMessages.armyListFormMaxPlaceholder}
                />
              </Col>
            </FormGroup>

          </CardBody>
          <div className="mb-2 text-center">
            <Button disabled={!canSubmit} color="age" type="submit"><FormattedMessage {...defaultMessages.formSearch} /></Button>
          </div>
        </Card>
      </Col>
    </form>
  );
}

var SearchArmyListForm = reduxForm<SearchArmyListParams, Props>({
  form: 'search_army_list',
  validate,
})(Form);

// Decorate with connect to read form values
// @ts-ignore
const selector = formValueSelector('search_army_list') // <-- same as form name

const mapStateToProps = (state: AppState, props: Props) => {
  // can select values individually
  let version = selector(state, 'versionId') ?? null;
  if (!version) {
    version = props.versions
      .flatMap(item => item.options)
      .filter(item => item.game === VersionGame.NinthAge)
      .sort((a, b) => b.id - a.id)
      .slice(0, 1)
      .shift()
      ?.id;
  }
  return {
    versions: props.versions,
    armies: props.armies.filter(item => version != null && item.versionId == version),
    onSubmit: props.onSubmit,
    initialValues: {
      max: 4500,
      min: 0,
      versionId: version,
      armyId: props.armies.filter(item => version != null && item.versionId == version)
        .slice(0, 1)
        .shift()
        ?.id
    },
  }
}

export default connect(mapStateToProps)(SearchArmyListForm);
